export function isPublicAuthPath(path: string): boolean {
  const pathname = path.split('?')[0];
  return /^\/(login|register|sso)(\/|$)/.test(pathname);
}
